var map = {
	"./abc/placeholder_UB.jpg": "fc3a",
	"./abc/placeholder_UBlog.jpg": "9f55",
	"./abc/placeholder_UF.jpg": "731a",
	"./abc/placeholder_UHK.jpg": "1e1c",
	"./abc/placeholder_UL.jpg": "6ab6",
	"./abc/placeholder_UT.jpg": "5c4f",
	"./arrow_drop_down.svg": "0d08",
	"./bg.jpg": "d1b4",
	"./bg2.jpg": "8de0",
	"./bg3.jpg": "b691",
	"./close.svg": "1d1b",
	"./couponupdate/back.svg": "5d34",
	"./couponupdate/category.svg": "22e0",
	"./couponupdate/expire-date.svg": "41a1",
	"./couponupdate/mobile-update.svg": "7169",
	"./couponupdate/publish-due.svg": "ccb0",
	"./couponupdate/remove-category.svg": "b5e0",
	"./couponupdate/remove.svg": "7a49",
	"./couponupdate/tick.svg": "de2f",
	"./couponupdate/unpublish.svg": "ab2c",
	"./deliverystatus/history.svg": "8ef7",
	"./empty-state-graphic.png": "1f3a",
	"./help-24px-blue.svg": "c7a3",
	"./icon.jpg": "d8fc",
	"./icon/arrow-down.svg": "85e9",
	"./icon/arrow-left.svg": "52d0",
	"./icon/arrow-up.svg": "c545",
	"./icon/calendar-mobile.svg": "f770",
	"./icon/calendar.svg": "8117",
	"./icon/cashout-active.svg": "8ad3",
	"./icon/cashout.svg": "e5c9",
	"./icon/chart-active.svg": "5990",
	"./icon/chart.svg": "fec3",
	"./icon/clock.svg": "a451",
	"./icon/cloud-upload.png": "caf1",
	"./icon/community-active.svg": "eae7",
	"./icon/community.svg": "689e",
	"./icon/coupon-active.svg": "2aa2",
	"./icon/coupon.svg": "18e9",
	"./icon/delete-img@4x.png": "bdc6",
	"./icon/delivery.svg": "681c",
	"./icon/edit.svg": "0e3d",
	"./icon/email.svg": "5568",
	"./icon/export.svg": "0159",
	"./icon/first-page.svg": "1db9",
	"./icon/help-active.svg": "51b9",
	"./icon/help.svg": "9fc2",
	"./icon/home-active.svg": "6992",
	"./icon/home.svg": "3690",
	"./icon/icn-send-active.svg": "30e1",
	"./icon/icn-send.svg": "e3a1",
	"./icon/last-page.svg": "9d78",
	"./icon/left-arrow.svg": "2f8f",
	"./icon/logout.svg": "5ad1",
	"./icon/merchant-active.svg": "aadf",
	"./icon/merchant.svg": "bcde",
	"./icon/mobile-add.svg": "c8f0",
	"./icon/mobile-calendar.svg": "5886",
	"./icon/mobile-check.svg": "f0a3",
	"./icon/mobile-export.svg": "d586",
	"./icon/mobile-more.svg": "b2b7",
	"./icon/mobile-sidebar.svg": "5541",
	"./icon/new-tag.svg": "b8ab",
	"./icon/news.svg": "afb4",
	"./icon/notification-active.svg": "c1d7",
	"./icon/notification.svg": "9eb8",
	"./icon/order-active.svg": "ab75",
	"./icon/order.svg": "b340",
	"./icon/paid-coupon-active.svg": "f5ac",
	"./icon/paid-coupon.svg": "c38f",
	"./icon/remove.svg": "5208",
	"./icon/right-arrow.svg": "15eb",
	"./icon/rise.svg": "2e4a",
	"./icon/scan-active.svg": "a793",
	"./icon/scan.svg": "bd53",
	"./icon/search-coupon.svg": "ffdd",
	"./icon/search.svg": "ca1b",
	"./icon/setting-active.svg": "02c1",
	"./icon/setting.svg": "e802",
	"./icon/sidebar.svg": "d96e",
	"./icon/template-active.svg": "09ff",
	"./icon/template.svg": "5eac",
	"./icon/tick.svg": "365d",
	"./icon/tnc-active.svg": "fe65",
	"./icon/tnc.svg": "0dd4",
	"./icon/tutorial.svg": "3bb8",
	"./loading.svg": "333e",
	"./merchant-page-graphic1@4x.png": "8363",
	"./merchant-page-graphic2@4x.png": "a00b",
	"./merchant/empty-cover-photo.png": "8f74",
	"./new_bg_img.svg": "e982",
	"./news.svg": "a1e0",
	"./notification/merchantcenter-blog.dummycover.png": "67d9",
	"./notification/noti-phone-full.png": "7d3d",
	"./notification/noti-phone-large.png": "4b6e",
	"./notification/noti-qr-large.png": "78d0",
	"./notification/noti-qr.png": "5da3",
	"./order.png": "d6d9",
	"./paidcoupon.png": "1bec",
	"./paymentstatusimg/status-icn_redeemed@3x.png": "9cfe",
	"./paymentstatusimg/status-icn_redeemed_coupon@3x.png": "5cc3",
	"./paymentstatusimg/status-icn_refund_finished@3x.png": "e032",
	"./paymentstatusimg/status-icn_refund_finished_coupon@3x.png": "026a",
	"./paymentstatusimg/status-icn_refund_pending@3x.png": "9ff7",
	"./paymentstatusimg/status-icn_refund_pending_coupon@3x.png": "d5b2",
	"./pdf-logo.png": "b58d",
	"./preview-app-bottomtab.png": "bf21",
	"./profile-cover.jpg": "077d",
	"./qrcode/qrcode.png": "f873",
	"./search.svg": "6f6b",
	"./statistics/browse.svg": "c43b",
	"./statistics/cate.svg": "5276",
	"./statistics/deal.svg": "0c27",
	"./statistics/list.svg": "46c3",
	"./statistics/no-data.svg": "ea66",
	"./status-icn_activated@3x.png": "db58",
	"./status-icn_actual-used-total@3x.png": "746a",
	"./status-icn_cancel_completed@3x.png": "2a30",
	"./status-icn_draft@3x.png": "6d59",
	"./status-icn_expired@3x.png": "cf4a",
	"./status-icn_finished@3x.png": "e3c9",
	"./status-icn_inactivated@3x.png": "4a1a",
	"./status-icn_pending@3x.png": "7572",
	"./status-icn_published@3x.png": "5420",
	"./status-icn_redeemed@3x.png": "16ee",
	"./status-icn_refund_finished@3x.png": "818e",
	"./status-icn_refund_pending@3x.png": "5c33",
	"./status-icn_rejected@3x.png": "1c8b",
	"./status-icn_removed@3x.png": "b01b",
	"./status-icn_scheduled@3x.png": "2169",
	"./status-icn_stop@3x.png": "ba9c",
	"./status-icn_stopped@3x.png": "ebda",
	"./status-icn_unpublished@3x.png": "e7da",
	"./status-icn_used@3x.png": "f4c0",
	"./success.svg": "d1ae",
	"./tooltip_default.png": "dcac",
	"./ufun@3x.png": "e742",
	"./ufuncoupon.png": "0b7d",
	"./ul-logo.png": "c721"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";